import {useAppDensity} from "../app/AppContext";
import {OtsDataTableEmpty} from "../components/OtsDataTableCells";
import {OtsDialog} from "../components/OtsDialog";
import {DecisionSteps} from "../decision-graph/DecisionSteps";
import type {DecisionGraphModel} from "../decision-graph/decision-graph-model";
import type {OtsBrand, OtsColorSchemePreference} from "../theme/OtsTheme";

export type ContainerLoadCalculationDialogProps = {
  open: boolean;
  onClose: () => void;
  /** The container the calculation was opened from; its group shares one calculation. */
  containerName?: string;
  graph?: DecisionGraphModel | null;
  brand?: OtsBrand;
  colorScheme?: OtsColorSchemePreference;
  compact?: boolean;
};

/** How a container's available loads were calculated: the totals, then the settings, grouping and each container's steps. */
export const ContainerLoadCalculationDialog = ({
  open, onClose, containerName, graph, brand, colorScheme, compact: compactProp,
}: ContainerLoadCalculationDialogProps) => {
  const density = useAppDensity();
  const compact = compactProp ?? density === "compact";

  const title = containerName ? `Available loads · ${containerName}` : "Available loads";

  return <OtsDialog open={open} onClose={onClose} brand={brand} colorScheme={colorScheme} compact={compact} size="3xl" title={title}
    description="The settings, grouping and fill used to count this container's available loads.">
    {graph && graph.nodes.length > 0
      ? <DecisionSteps model={graph} label="How the available loads were calculated" copyTitle={title}
        highlight={containerName ? node => node.title === containerName : undefined} highlightLabel="This container"/>
      : <OtsDataTableEmpty compact={compact}>No available load calculation was recorded for this container.</OtsDataTableEmpty>}
  </OtsDialog>;
};
